import React from 'react';
import { Pagination } from 'antd';
import propTypes from 'prop-types';
import './pagination.scss';
import IconPrev from '../../../assets/images/icons/icons-chevron-left.svg';
import IconNext from '../../../assets/images/icons/icons-chevron-right.svg';

const CustomPagination = (props) => {
  const itemRender = (current, type, originEl) => {
    if (type === 'prev') {
      return <img src={IconPrev} alt="icon prev" />;
    }
    if (type === 'next') {
      return <img src={IconNext} alt="icon next" />;
    }
    return originEl;
  };
  return <Pagination {...props} showSizeChanger={false} itemRender={itemRender} />;
};

CustomPagination.propTypes = {
  onChange: propTypes.func,
  total: propTypes.number,
};
export default CustomPagination;
